import { defineMessages } from 'react-intl';

export default defineMessages({
  deactivatedSuccess: {
    id: 'company.detail.deactivatedSuccess',
    defaultMessage: 'Company PIC telah di non-aktifkan',
  },
  activatedSuccess: {
    id: 'company.detail.deactivatedSuccess',
    defaultMessage: 'Company PIC telah di aktifkan',
  },
  role2: {
    id: 'company.detail.form.role.2',
    defaultMessage: 'Company',
  },
  role3: {
    id: 'company.detail.form.role.3',
    defaultMessage: 'Agent',
  },
  labelEmail: {
    id: 'company.detail.form.label.email',
    defaultMessage: 'Company Email Address',
  },
  labelRole: {
    id: 'company.detail.form.label.role',
    defaultMessage: 'Company Account Role',
  },
  labelUsername: {
    id: 'company.detail.form.label.username',
    defaultMessage: 'Company Username',
  },
  labelPassword: {
    id: 'company.detail.form.label.password',
    defaultMessage: 'Password',
  },
  labelAddress: {
    id: 'company.detail.form.label.address',
    defaultMessage: 'Alamat Company',
  },
  labelOwner: {
    id: 'company.detail.form.label.owner',
    defaultMessage: 'Company Owner',
  },
  labelName: {
    id: 'company.detail.form.label.name',
    defaultMessage: 'Company Name',
  },
  labelCompanyId: {
    id: 'company.detail.form.label.companyId',
    defaultMessage: 'Company ID',
  },
  btnEdit: {
    id: 'company.btn.edit',
    defaultMessage: 'Ubah',
  },
  btnDeactivated: {
    id: 'company.btn.deactivated',
    defaultMessage: 'Non-aktifkan',
  },
  breadcrumbList: {
    id: 'company.breadcrumb.list',
    defaultMessage: 'Company List',
  },
  breadcrumbDetail: {
    id: 'company.breadcrumb.detail',
    defaultMessage: 'Company Detail',
  },
  title: {
    id: 'company.detail.title',
    defaultMessage: 'Company Detail',
  },
  labelPicName: {
    id: 'company.detail.form.label.picName',
    defaultMessage: 'Company PIC Name',
  },
  labelPicPhone: {
    id: 'company.detail.form.label.picPhone',
    defaultMessage: 'Company PIC Phone Number',
  },
  labelPicPhoto: {
    id: 'company.detail.form.label.picPhoto',
    defaultMessage: 'Company PIC Photo',
  },
  labelCompanyModule: {
    id: 'company.detail.form.label.companyModule',
    defaultMessage: 'Company Module',
  },
  labelCompanyPermission: {
    id: 'company.detail.form.label.companyPermission',
    defaultMessage: 'Company Permission',
  },
  labelNpwpNumber: {
    id: 'company.detail.form.label.npwpNumber',
    defaultMessage: 'NPWP Number',
  },
  labelLegalEntity: {
    id: 'company.detail.form.label.legalEntity',
    defaultMessage: 'Legal Entity',
  },
});
